// extracted by mini-css-extract-plugin
export default {"root":"IconSynchronize_root__oDr6z"};